import React, { useRef, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon, MailIcon, PhoneIcon } from '@heroicons/react/outline';
import Input from 'react-phone-number-input/input'
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { useLocation } from 'react-router-dom';
import { fireRedTrackLead } from '../../redtrack';

export default function Step12({ prevStep,
    nextStep,
    updateFieldValue,
    taxDebtType,
    taxDebtKind,
    enrollmentPlan,
    totalDebt,
    grossMonthlyIncome,
    creditScore,
    unfiledTaxReturns,
    description,
    ...FormFields }) {

    const [status, setStatus] = useState('');
    const [altPathUnder5000, setAltPathUnder5000] = useState(false)
    const [showCallNow, setShowCallNow] = useState(false);
    const recaptchaRef = useRef(null);
    const location = useLocation();
    const [disabledButton, setDisabledButton] = useState(false)

    const getTaxDebtAmount = (range) => { //minimum value of the range
        switch (range) {
            case "$1 - $4,999":
                return 1;

            case "$5,000 - $9,999":
                return 5000;

            case "$10,000 - $29,999":
                return 10000;

            case "$30,000 - $49,999":
                return 30000;

            case "$50,000 or more":
                return 50000;

            default:
                return 0;
        }
    };

    const handlePost = async (e) => {
        setDisabledButton(true)
        const taxDebtAmount = getTaxDebtAmount(totalDebt)


        try {
            // 1. Get reCAPTCHA token
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset();

            const payloadData =
            {
                "landing_page": location.pathname,
                "email": FormFields.email,
                "firstname": FormFields.firstName,
                "lastname": FormFields.lastName,
                "phone": FormFields.cellPhone,
                "are_you_currently_enrolled_in_a_payment_installment_agreement_": enrollmentPlan,
                "amount": taxDebtAmount,
                "how_much_do_you_estimate_you_owe_in_back_taxes_": totalDebt,
                "do_you_have_tax_debt_with_the_irs_or_your_state_": "Yes",
                "gross_monthly_income": grossMonthlyIncome,
                "credit_score": creditScore,
                "unfiled_returns": unfiledTaxReturns,
                "what_kind_of_tax_debt_do_you_need_help_with_": taxDebtKind,
                "i_affirm_that_i_ve_reviewed_and_accepted_ovation_tax_group_sterms_and_conditionsandprivacy_policy_": "Yes",
                "by_checking_this_box__i_agree_to_receive_communications__including_email__calls_and_text_messages_f": "Yes",
            }

            // 2. Verify reCAPTCHA via Vercel serverless function
            const res = await fetch('/api/verify-recaptcha', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: recaptchaToken }),
            });
            const data = await res.json();

            if (!data.success) {
                // console.error('Recaptcha failed:', data);
                // Show error to user
                setStatus('Failed reCAPTCHA. Please try again.');
            }

            //2b. Honeypot
            if (FormFields.description) {
                // Show alt screen
                setAltPathUnder5000(true)
                return;
            }

            // 2c. get cookie value for hubspot click id
            function getCookie(name) {
                const prefix = `${name}=`;

                const entry = document.cookie
                    .split("; ")
                    .find((item) => item.startsWith(prefix));

                return entry
                    ? decodeURIComponent(entry.slice(prefix.length))
                    : "";
            }

            const trackingContext = {
                hubspotutk: getCookie("hubspotutk") || "",
                pageUrl: window.location.href,
                pageName: document.title,
            };


            // 3. Send data to HubSpot
            const clickId = sessionStorage.getItem("rt_clickid") || "";

            const payload = {
                ...payloadData,
                ...trackingContext,
                rtkclickid: clickId
            };

            const response = await axios.post('/api/hubspot-lead', payload);

            if (response.data.existingContact) {
                // Show Call Now screen
                console.log('Existing lead');
                setShowCallNow(true);
                return;
            }

            if (response.status === 200) {
                console.log('Lead submitted successfully');
                // Fire RedTrack Lead event
                fireRedTrackLead({
                    email: FormFields.email,
                    phone: FormFields.cellPhone,
                    firstName: FormFields.firstName,
                    lastName: FormFields.lastName
                });
                // Facebook Lead Event
                // trackEvent('Lead', { content_name: 'Signup Form' });
                // Success modal
                console.log("Lead submitted successfully:", response.data);
                // console.log(endpoint, payload)
                nextStep(12)
                // Navigate to the next page after successful submission
                setDisabledButton(false)
            }


        } catch (error) {
            alert("Something went wrong. Please try again. ")
            console.error("Error submitting lead:", error.response?.data || error.message);
            setStatus('Something went wrong. Please try again.');
        }


    };


    return (
        <div>
            {showCallNow ?
                <div className="text-center max-w-lg mx-auto p-10">
                    <div className="text-center block text-xl font-semibold mb-2 text-gray-900">
                        We've Already Received Your Information
                    </div>

                    <p className="text-center text-base py-5 md:p-10 text-gray-900">
                        To avoid waiting for a callback, call now to speak directly with a tax relief specialist. Our team can <b>review your situation immediately</b> and answer any questions about your options.
                    </p>

                    <a href="tel:8449844926" className='hover:underline text-blue-600 flex items-center justify-center text-lg'> <PhoneIcon className='h-4 w-4 mr-2' /> (844) 984-4926</a>

                    <p className="mt-4 text-gray-600">
                        Representatives are standing by.
                    </p>
                    <div className='text-center mt-2 text-blue-500 text-xs'>
                        <a href="/terms-conditions" className='text-blue-500 mr-1 hover:underline'>Terms &amp; Conditions</a>|
                        <a href="/privacy-policy" className='text-blue-500 mx-1 hover:underline'>Privacy Policy</a>|
                        <a href="/cookie-policy" className='text-blue-500 ml-1 hover:underline'>Cookie Policy</a>
                    </div>
                </div>
                :

                altPathUnder5000 ?
                    <div>
                        <div className='max-w-lg mx-auto p-10'>
                            <div className="text-center block text-xl font-semibold mb-2 text-gray-900">
                                Thank you for completing the survey!
                            </div>
                            <p className='text-center text-base py-5 md:p-10 text-gray-900'>We are currently not taking on clients with your particular tax debt situation at this time. If you believe this is a mistake please give us a call at <a href="tel:8449844926" className='hover:underline text-blue-600'> (844) 984-4926</a>.
                            </p>
                            <div className='text-center mt-2 text-blue-500 text-xs'>
                                <a href="/terms-conditions" className='text-blue-500 mr-1 hover:underline'>Terms &amp; Conditions</a>|
                                <a href="/privacy-policy" className='text-blue-500 mx-1 hover:underline'>Privacy Policy</a>|
                                <a href="/cookie-policy" className='text-blue-500 ml-1 hover:underline'>Cookie Policy</a>
                            </div>
                        </div>
                    </div >
                    :
                    <div>


                        <form>
                            <div className='max-w-lg mx-auto p-10'>
                                <div className="text-center block text-xl font-semibold mb-2 text-gray-900">
                                    Thank you for completing the survey!
                                </div>
                                <div className="hidden">
                                    <label htmlFor={`description`} className="block text-sm font-medium capitalize mb-2 text-gray-700">
                                        Describe your tax problem in more detail *
                                    </label>
                                    <input
                                        type="text"
                                        name="description"
                                        maxLength="100"
                                        id={`description`}
                                        defaultValue=""
                                        onChange={(event) => updateFieldValue("description", event.target.value)}
                                        className={`px-4 border-gray-400 border font-semibold py-1 text-base w-full text-black bg-white`}
                                    />
                                </div>

                                <p className='text-center text-base'>Click "Submit" for your FREE tax resolution consultation</p>
                                <p className='max-w-sm text-gray-400 text-xs mt-5 text-justify mx-auto'>
                                    By clicking submit, I give Ovation Tax Group LLC and any of our partners, affiliates, agents, assigns, and service providers express written permission to contact me at the number and email provided above, via email, phone, text message (SMS/MMS), and/or cell phone, including the use of automated dialing equipment, artificial intelligence, and pre-recorded calls and/or messages for informational or promotional purposes. Message and data rates may apply. Message frequency varies.You further agree that Ovation Tax Group LLC may send emails to you at any email address you provide us or use other electronic means of communication to the extent permitted by law. Consent can be revoked at any time by replying STOP to any text message. Your consent to these terms is not a condition of purchase. For more information, please review our Privacy Policy.
                                </p>
                                <div className='text-center mt-2 text-blue-500 text-xs'>
                                    <a href="/terms-conditions" className='text-blue-500 mr-1 hover:underline'>Terms &amp; Conditions</a>|
                                    <a href="/privacy-policy" className='text-blue-500 mx-1 hover:underline'>Privacy Policy</a>|
                                    <a href="/cookie-policy" className='text-blue-500 ml-1 hover:underline'>Cookie Policy</a>
                                </div>


                            </div>
                            {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                                <>
                                    {/* Invisible reCAPTCHA */}
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        size="invisible"
                                        ref={recaptchaRef}
                                    />
                                    <p className='mt-2 absolute text-sm'>{status}</p>
                                </>
                            ) : (
                                <p style={{ color: 'red' }}>reCAPTCHA sitekey is missing.</p>
                            )}

                            <div className="relative flex items-center justify-end w-full h-14 bg-blue-600 rounded-b-md">
                                {/* <button
                                    id="calcStep12Prev"
                                    onClick={() => prevStep(12)}
                                    className="flex items-center w-fit h-full rounded-l-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                                </button> */}

                                {/* Centered Step Counter */}
                                {/* <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                                    12 of 12
                                </div> */}

                                {/* Next Button */}
                                <button
                                    id="calculatorFormSubmitButton"
                                    onClick={(e) => handlePost(e)}
                                    disabled={disabledButton}
                                    className={`flex items-center text-xl h-full px-5 font-semibold text-white uppercase rounded-br-md ${disabledButton ? "bg-blue-400 cursor-progress" : "cursor-pointer bg-blue-600 hover:bg-blue-800"}`}
                                >
                                    Submit
                                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                                </button>
                            </div>


                        </form>
                    </div>


            }
        </div>
    );

}